import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { COLORS } from 'apps/web_forms/utils/constants';
import CloseIcon from 'apps/web_forms/assets/close.svg';

const StyledDisplayImageContainer = styled.div`
  position: relative;
  width: 45%;
  margin: 0.9em 0;
  img {
    width: 100%;
  }
  button {
    background-color: #dddddd;
    border: none;
    position: absolute;
    top: -0.6em;
    right: -0.6em;
    border-radius: 50%;
    width: 1.5em;
    height: 1.5em;
    svg {
      margin-top: 0.2em;
      width: 0.75em;
      height: 0.75em;
      fill: ${COLORS.grey};
    }
  }
`;

const ThumbnailImage = ({ identifier, srcValue, thumbnailUrl, onClose }) => {
  return (
    <StyledDisplayImageContainer id={`${identifier}_preview`}>
      <a href={thumbnailUrl || null} target="_blank" rel="noreferrer">
        <img src={srcValue} data-testid="uploaded-thumbnail" alt="" />
      </a>
      <button
        type="button"
        id={`${identifier}_delete_webcam_button`}
        aria-label="Remove"
        onClick={onClose}
      >
        <CloseIcon />
      </button>
    </StyledDisplayImageContainer>
  );
};

ThumbnailImage.propTypes = {
  // identifier: PropTypes.string.isRequired,
  srcValue: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

ThumbnailImage.defaultProps = {
  thumbnailUrl: '',
};

export default ThumbnailImage;
